module.exports = __webpack_public_path__ + "media/images/prevention_form/mischkonsum-e08f21c7acad9d2c672759a5eb678b7e.svg";